module.exports = __webpack_public_path__ + "static/media/100_Racoon_coins.6f90421e.webp";